import { Component } from '@angular/core';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { SummaryPricesService } from '../summary/summary-prices.service';

@Component({
  selector: 'new-offer-details-business-summary',
  templateUrl: './new-offer-details-business-summary.component.html',
})
export class NewOfferDetailsBusinessSummaryComponent {
  public summaryPrices: SummaryPricesService;
  public currencySymbol = 'zł';

  constructor(
    public commonInfo: CommonInfoService,
    private summaryPricesModel: SummaryPricesService,
  ) {
    this.summaryPrices = this.summaryPricesModel;
  }

}

